import type { RouteRecordRaw } from 'vue-router';
import { voucherCodesMonitorRoutesDictionary } from './voucher-codes-monitor-routes.dictionary.ts';

export const voucherCodesMonitorRoutesConfig: RouteRecordRaw = {
  ...voucherCodesMonitorRoutesDictionary.voucherCodesMonitor.root,
  redirect: {
    name: voucherCodesMonitorRoutesDictionary.voucherCodesMonitor.list.name,
  },
  children: [
    {
      ...voucherCodesMonitorRoutesDictionary.voucherCodesMonitor.list,
      component: () => import('../pages/List/VoucherCodesMonitorListPage.vue'),
    },
  ],
};
